export const ErrorMessageStyles = {
  error: 'text-red200',
}
